"use client";

import { memo, type FC } from "react";
import { SSRWrapper } from "@huub-web/ui";

import {
  DynamicMapboxView,
  type DynamicMapboxViewProps,
  type MapboxMapViewHandle,
} from "./components/DynamicMapboxView";

export type MapboxMapViewProps = DynamicMapboxViewProps;
export type { MapboxMapViewHandle };

/**
 * MapboxMapView component that safely loads Mapbox on client-side only
 * Works with both Next.js and Vite
 *
 * @example
 * ```tsx
 * <MapboxMapView
 *   center={[4.9041, 52.3676]} // [longitude, latitude]
 *   zoom={14}
 *   accessToken={process.env.NEXT_PUBLIC_MAPBOX_TOKEN}
 * />
 * ```
 */
export const MapboxMapView: FC<MapboxMapViewProps> = memo(
  function MapboxMapView({ ref, ...props }) {
    return (
      <SSRWrapper>
        <DynamicMapboxView {...props} ref={ref} />
      </SSRWrapper>
    );
  },
);
